<template>
    <div translate="no" class="margin-top-20 margin-left-20">
        <div class="select-container no-print">
            <b-form-select v-model="selected" :options="options" class="custom-select"></b-form-select>
        </div>
        <div id="printable-content">
            <table width="586" border="0" cellspacing="0" cellpadding="0" align="center">
                <tbody>
                    <tr>
                        <td>
                            <table width="100%" border="0" cellpadding="0" cellspacing="0">
                                <tbody>
                                    <tr>
                                        <td style="font-size:11px; color:red;">[별지 제11호 서식]</td>
                                        <td align="right" style="font-size:11px; color:red;">[00]</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <table width="100%" style="border:1px solid red; border-collapse:collapse;">
                                <tbody>
                                    <tr>
                                        <td>
                                            <table width="100%" style="border-collapse:collapse;">
                                                <tbody>
                                                    <tr>
                                                        <td width="70%" align="center" style="padding:5px 0;">
                                                            <span style="font-size:22px; color:red; font-weight:bold;">세
                                                                금 계 산 서</span>
                                                            <span style="font-size:11px; color:red;">(2025년 03월
                                                                판매분)</span>
                                                        </td>
                                                        <td width="30%">
                                                            <table width="100%" style="border-collapse:collapse;">
                                                                <tbody>
                                                                    <tr>
                                                                        <td width="40%"
                                                                            style="border:1px solid red; border-right:none; border-top:none; font-size:11px; text-align:center; padding:1px;">
                                                                            <span style="color:red;">책번호</span>
                                                                        </td>
                                                                        <td width="30%"
                                                                            style="border:1px solid red; border-right:none; border-top:none; font-size:11px; text-align:right; padding-right:5px; color:red;">
                                                                            권
                                                                        </td>
                                                                        <td width="30%"
                                                                            style="border:1px solid red; border-top:none;  text-align:right; border-right:none; font-size:11px;  padding-right:5px; color:red;">
                                                                            호
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="40%"
                                                                            style="border:1px solid red; border-right:none; border-top:none; border-bottom:none; font-size:11px; text-align:center; padding:1px;">
                                                                            <span style="color:red;">일련번호</span>
                                                                        </td>
                                                                        <td colspan="2"
                                                                            style="border:1px solid red; border-top:none; border-bottom:none; border-right:none; font-size:11px; text-align:center; padding:1px;">
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <table width="100%" style="border-collapse:collapse;">
                                                <tbody>
                                                    <tr>
                                                        <td width="50%"
                                                            style="border-top:1px solid red; border-right:1px solid red; border-bottom:1px solid red; padding:0;">
                                                            <table width="100%"
                                                                style="border-collapse:collapse; table-layout:fixed; height:100%;">
                                                                <tbody>
                                                                    <tr>
                                                                        <td width="20" rowspan="4"
                                                                            style="border-right:1px solid red; text-align:center; vertical-align:middle; padding:0; height:140px;">
                                                                            <span
                                                                                style="font-size:11px; color:red;">공<br>급<br>자</span>
                                                                        </td>
                                                                        <td width="60"
                                                                            style="border-right:1px solid red; border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                            <span
                                                                                style="font-size:11px; color:red;">등록번호</span>
                                                                        </td>
                                                                        <td
                                                                            style="border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                            <span
                                                                                style="font-size:16px; font-weight:bold;">104-38-61243</span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style="border-right:1px solid red; border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                            <span
                                                                                style="font-size:11px; color:red;">상호<br>(법인명)</span>
                                                                        </td>
                                                                        <td
                                                                            style="border-bottom:1px solid red; padding:0; height:35px;">
                                                                            <table width="100%"
                                                                                style="border-collapse:collapse; table-layout:fixed; height:100%;">
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td
                                                                                            style="text-align:center; font-size:11px; word-break:break-all; word-wrap:break-word; height:35px; vertical-align:middle;">
                                                                                            넥스트랩 현대시티아울렛 대구점
                                                                                        </td>
                                                                                        <td width="20"
                                                                                            style="border-left:1px solid red; border-right:1px solid red; text-align:center; height:35px; vertical-align:middle;">
                                                                                            <span
                                                                                                style="font-size:11px; color:red;">성<br>명</span>
                                                                                        </td>
                                                                                        <td width="80"
                                                                                            style="text-align:center; font-size:11px; height:35px; vertical-align:middle;">
                                                                                            김정하<span
                                                                                                style="color:red;">(인)</span>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style="border-right:1px solid red; border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                            <span
                                                                                style="font-size:11px; color:red;">사업장<br>주소</span>
                                                                        </td>
                                                                        <td
                                                                            style="border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                            <span
                                                                                style="font-size:10px; word-break:break-all; word-wrap:break-word;">대구광역시
                                                                                동구 동대구로 454 (신천동) 현대시티아울렛 6층</span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style="border-right:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                            <span
                                                                                style="font-size:11px; color:red;">업태</span>
                                                                        </td>
                                                                        <td style="padding:0; height:35px;">
                                                                            <table width="100%"
                                                                                style="border-collapse:collapse; table-layout:fixed; height:100%;">
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td
                                                                                            style="text-align:center; font-size:11px; word-break:break-all; word-wrap:break-word; height:35px; vertical-align:middle;">
                                                                                            소매</td>
                                                                                        <td width="20"
                                                                                            style="border-left:1px solid red; border-right:1px solid red; text-align:center; height:35px; vertical-align:middle;">
                                                                                            <span
                                                                                                style="font-size:11px; color:red;">종목</span>
                                                                                        </td>
                                                                                        <td
                                                                                            style="text-align:center; font-size:11px; word-break:break-all; word-wrap:break-word; height:35px; vertical-align:middle;">
                                                                                            상품대리</td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td width="50%"
                                                            style="border-top:1px solid red;  border-bottom:1px solid red; padding:0;">
                                                            <table width="100%"
                                                                style="border-collapse:collapse; table-layout:fixed; height:100%;">
                                                                <tbody>
                                                                    <tr>
                                                                        <td width="20" rowspan="4"
                                                                            style="border-right:1px solid red; text-align:center; vertical-align:middle; padding:0; height:140px;">
                                                                            <span
                                                                                style="font-size:11px; color:red;">공<br>급<br>받<br>는<br>자</span>
                                                                        </td>
                                                                        <td width="60"
                                                                            style="border-right:1px solid red; border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                            <span
                                                                                style="font-size:11px; color:red;">등록번호</span>
                                                                        </td>
                                                                        <td
                                                                            style="border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                            <span
                                                                                style="font-size:16px; font-weight:bold;">220-81-01830</span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style="border-right:1px solid red; border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                            <span
                                                                                style="font-size:11px; color:red;">상호<br>(법인명)</span>
                                                                        </td>
                                                                        <td
                                                                            style="border-bottom:1px solid red; padding:0; height:35px;">
                                                                            <table width="100%"
                                                                                style="border-collapse:collapse; table-layout:fixed; height:100%;">
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td
                                                                                            style="text-align:center; font-size:11px; word-break:break-all; word-wrap:break-word; height:35px; vertical-align:middle;">
                                                                                            (주)아가방앤컴퍼니
                                                                                        </td>
                                                                                        <td width="20"
                                                                                            style="border-left:1px solid red; border-right:1px solid red; text-align:center; height:35px; vertical-align:middle;">
                                                                                            <span
                                                                                                style="font-size:11px; color:red;">성<br>명</span>
                                                                                        </td>
                                                                                        <td width="80"
                                                                                            style="text-align:center; font-size:9px; height:35px; vertical-align:middle;">
                                                                                            SHEN XIANGGUO<br>신상국<span
                                                                                                style="color:red;">(인)</span>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style="border-right:1px solid red; border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                            <span
                                                                                style="font-size:11px; color:red;">사업장<br>주소</span>
                                                                        </td>
                                                                        <td
                                                                            style="border-bottom:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                            <span
                                                                                style="font-size:10px; word-break:break-all; word-wrap:break-word;">서울특별시
                                                                                강남구 테헤란로207, 8층(역삼동)</span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td
                                                                            style="border-right:1px solid red; text-align:center; padding:0; height:35px; vertical-align:middle;">
                                                                            <span
                                                                                style="font-size:11px; color:red;">업태</span>
                                                                        </td>
                                                                        <td style="padding:0; height:35px;">
                                                                            <table width="100%"
                                                                                style="border-collapse:collapse; table-layout:fixed; height:100%;">
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td
                                                                                            style="text-align:center; font-size:11px; word-break:break-all; word-wrap:break-word; height:35px; vertical-align:middle;">
                                                                                            제조, 도매<br>부동산
                                                                                        </td>
                                                                                        <td width="20"
                                                                                            style="border-left:1px solid red; border-right:1px solid red; text-align:center; height:35px; vertical-align:middle;">
                                                                                            <span
                                                                                                style="font-size:11px; color:red;">종목</span>
                                                                                        </td>
                                                                                        <td
                                                                                            style="text-align:center; font-size:11px; word-break:break-all; word-wrap:break-word; height:35px; vertical-align:middle;">
                                                                                            의류, 완구<br>임대
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr style="border-top:1px solid red; ">
                                        <td colspan="2">
                                            <table width="100%" border="0" cellspacing="0" cellpadding="0"
                                                class="cborder2"
                                                style="border-top-style:none;border-left-style:none; border-right: none; ">
                                                <tbody>
                                                    <tr height="20">
                                                        <td class="cborder2"
                                                            style="border-top-style:none;border-left-style:none"
                                                            align="center"><span class="ttxt2">작 성</span></td>
                                                        <td class="cborder2" style="border-top-style:none"
                                                            align="center">
                                                            <span class="ttxt2">공 급 가 액</span>
                                                        </td>
                                                        <td class="cborder2" style="border-top-style:none"
                                                            align="center">
                                                            <span class="ttxt2">세 액</span>
                                                        </td>
                                                        <td class="cborder2"
                                                            style="border-top-style:none; border-right: none;"
                                                            align="center">
                                                            <span class="ttxt2">비 고</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <table width="100%" border="0" cellspacing="0"
                                                                cellpadding="0">
                                                                <tbody>
                                                                    <tr height="20">
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none;border-left-style:none"
                                                                            align="center"><span class="ttxt2">년</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none"
                                                                            align="center"><span class="ttxt2">월</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; "
                                                                            align="center"><span class="ttxt2">일</span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr height="24">
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none;border-left-style:none; border-bottom: none;"
                                                                            align="center">2024</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">01</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">01</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td>
                                                            <table width="100%" border="0" cellspacing="0"
                                                                cellpadding="0">
                                                                <tbody>
                                                                    <tr height="20">
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-left:none; "
                                                                            align="center"><span
                                                                                class="ttxt2">공란수</span></td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; "
                                                                            align="center"><span class="ttxt2">백</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; "
                                                                            align="center"><span class="ttxt2">십</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none;"
                                                                            align="center"><span class="ttxt2">억</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; "
                                                                            align="center"><span class="ttxt2">천</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none;"
                                                                            align="center"><span class="ttxt2">백</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; "
                                                                            align="center"><span class="ttxt2">십</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; "
                                                                            align="center"><span class="ttxt2">만</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; "
                                                                            align="center"><span class="ttxt2">천</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; "
                                                                            align="center"><span class="ttxt2">백</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none;      "
                                                                            align="center"><span class="ttxt2">십</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; "
                                                                            align="center"><span class="ttxt2">일</span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr height="24">
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-left:none; border-bottom: none;"
                                                                            align="center">4</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td>
                                                            <table width="100%" border="0" cellspacing="0"
                                                                cellpadding="0">
                                                                <tbody>
                                                                    <tr height="20">
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-left:none"
                                                                            align="center"><span class="ttxt2">십</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none"
                                                                            align="center"><span class="ttxt2">억</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none"
                                                                            align="center"><span class="ttxt2">천</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none"
                                                                            align="center"><span class="ttxt2">백</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none"
                                                                            align="center"><span class="ttxt2">십</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none"
                                                                            align="center"><span class="ttxt2">만</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none"
                                                                            align="center"><span class="ttxt2">천</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none"
                                                                            align="center"><span class="ttxt2">백</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none"
                                                                            align="center"><span class="ttxt2">십</span>
                                                                        </td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-right:none;"
                                                                            align="center"><span class="ttxt2">일</span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr height="24">
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-left:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none;"
                                                                            align="center">0</td>
                                                                        <td class="cborder2"
                                                                            style="border-top-style:none; border-bottom: none; border-right:none;"
                                                                            align="center">0</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td class="cborder2"
                                                            style="border-top-style:none; border-right: none; "
                                                            align="center">00
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <table width="100%" style="border-collapse:collapse;">
                                                <tbody>
                                                    <tr>
                                                        <td width="4%" align="center"
                                                            style="border:1px solid red; border-right:none; border-left:none">
                                                            <span style="font-size:11px; color:red;">월</span>
                                                        </td>
                                                        <td width="4%" align="center"
                                                            style="border:1px solid red; border-left:none">
                                                            <span style="font-size:11px; color:red;">일</span>
                                                        </td>
                                                        <td width="25%" align="center" style="border:1px solid red;">
                                                            <span style="font-size:11px; color:red;">품목</span>
                                                        </td>
                                                        <td width="6%" align="center" style="border:1px solid red;">
                                                            <span style="font-size:11px; color:red;">규격</span>
                                                        </td>
                                                        <td width="6%" align="center" style="border:1px solid red;">
                                                            <span style="font-size:11px; color:red;">수량</span>
                                                        </td>
                                                        <td width="10%" align="center" style="border:1px solid red;">
                                                            <span style="font-size:11px; color:red;">단가</span>
                                                        </td>
                                                        <td width="22%" align="center" style="border:1px solid red;">
                                                            <span style="font-size:11px; color:red;">공급가액</span>
                                                        </td>
                                                        <td width="17%" align="center" style="border:1px solid red;">
                                                            <span style="font-size:11px; color:red;">세액</span>
                                                        </td>
                                                        <td width="6%" align="center"
                                                            style="border:1px solid red; border-right: none ;">
                                                            <span style="font-size:11px; color:red;">비 고</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td align="center"
                                                            style="border:1px solid red; border-right:none; border-left:none">
                                                            03</td>
                                                        <td align="center" style="border:1px solid red;">31</td>
                                                        <td align="left"
                                                            style="border:1px solid red; padding-left:5px;">25년 03월 판매분
                                                        </td>
                                                        <td align="center" style="border:1px solid red;"></td>
                                                        <td align="center" style="border:1px solid red;"></td>
                                                        <td align="center" style="border:1px solid red;"></td>
                                                        <td align="right"
                                                            style="border:1px solid red; padding-right:5px;">4,675,289
                                                        </td>
                                                        <td align="right"
                                                            style="border:1px solid red; padding-right:5px;">467,529
                                                        </td>
                                                        <td align="center"
                                                            style="border:1px solid red; border-right: none;"></td>
                                                    </tr>
                                                    <tr>
                                                        <td align="center"
                                                            style="border:1px solid red; border-left: none; border-bottom: none;">
                                                        </td>
                                                        <td align="center"
                                                            style="border:1px solid red; border-bottom: none;"></td>
                                                        <td align="left"
                                                            style="border:1px solid red; padding-left:5px; border-bottom: none;">
                                                            지급수수료</td>
                                                        <td align="center"
                                                            style="border:1px solid red; border-bottom: none;"></td>
                                                        <td align="center"
                                                            style="border:1px solid red; border-bottom: none;"></td>
                                                        <td align="center"
                                                            style="border:1px solid red; border-bottom: none;"></td>
                                                        <td align="center"
                                                            style="border:1px solid red; border-bottom: none;"></td>
                                                        <td align="center"
                                                            style="border:1px solid red; border-bottom: none;"></td>
                                                        <td align="center"
                                                            style="border:1px solid red; border-right:none; border-bottom: none;">
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr style="border-top: 1px solid red;">
                                        <td colspan="2">
                                            <table width="100%" style="border-collapse:collapse;">
                                                <tbody>
                                                    <tr>
                                                        <td width="25%" align="center"
                                                            style="border:1px solid red; border-left: none;">
                                                            <span style="font-size:12px; color:red;">합계금액</span>
                                                        </td>
                                                        <td width="10%" align="center" style="border:1px solid red;">
                                                            <span style="font-size:12px; color:red;">현금</span>
                                                        </td>
                                                        <td width="10%" align="center" style="border:1px solid red;">
                                                            <span style="font-size:12px; color:red;">수표</span>
                                                        </td>
                                                        <td width="10%" align="center" style="border:1px solid red;">
                                                            <span style="font-size:12px; color:red;">어음</span>
                                                        </td>
                                                        <td width="20%" align="center" style="border:1px solid red;">
                                                            <span style="font-size:12px; color:red;">외상미수금</span>
                                                        </td>
                                                        <td rowspan="5" align="center"
                                                            style="border-top: 1px solid red;">
                                                            <span style="font-size:12px; color:red;">이 금액을</span>
                                                            <strong> 영수 </strong>
                                                            <span style="font-size:12px; color:red;">함</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td align="center"
                                                            style="border:1px solid red; border-left: none; border-bottom:none">
                                                            5,142,818
                                                        </td>
                                                        <td align="center"
                                                            style="border:1px solid red; border-bottom:none;"></td>
                                                        <td align="center"
                                                            style="border:1px solid red; border-bottom:none;"></td>
                                                        <td align="center"
                                                            style="border:1px solid red; border-bottom:none;"></td>
                                                        <td align="center"
                                                            style="border:1px solid red; border-bottom:none;"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- 버튼 영역 -->
        <div class="action-buttons no-print">
            <div class="button-container">
                <button class="modern-button print-button" @click="printPage">
                    <PrinterIcon size="20" /> 인쇄
                </button>
                <button class="modern-button email-button" @click="showEmailModal = true">
                    <MailIcon size="20" /> 이메일 발송
                </button>
            </div>
            <v-dialog v-model="showEmailModal" max-width="500px">
                <v-card>
                    <v-card-title class="text-h5">이메일 전송</v-card-title>
                    <v-card-text>
                        <v-form ref="emailForm" @submit.prevent="handleSubmit">
                            <v-text-field v-model="email" label="받는 메일 주소" type="email" required
                                :rules="[v => !!v || '이메일 주소를 입력해주세요']"></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="handleCancel">취소</v-btn>
                        <v-btn color="blue darken-1" text @click="handleOk">전송</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <div class="notice-box">
                <p>*실제 통장입금 금액은 판촉물/부자재 금액 공제 후 입금되기 때문에 차이가 발생 합니다.</p>
                <p>*판촉물/부자재 내역은 출고반품 현황에서 확인 가능 합니다.(POS-현황관리-출고반품 현황)</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { PrinterIcon, MailIcon } from 'lucide-vue-next'
import Swal from 'sweetalert2'
import taxAPI from '@/api/tax/tax'

const selected = ref(null)
const options = ref([
    { value: '202403', text: '202403' }
])
const showEmailModal = ref(false)
const email = ref('')

const printPage = () => {
    window.print()
}

const handleOk = async () => {
    if (!email.value) {
        await Swal.fire({
            icon: 'warning',
            title: '이메일 주소를 입력해주세요'
        })
        return
    }
    await sendEmail()
    showEmailModal.value = false
}

const handleCancel = () => {
    email.value = ''
    showEmailModal.value = false
}

const handleSubmit = () => {
    // 폼 제출 처리
}

const sendEmail = async () => {
    if (!email.value) {
        await Swal.fire({
            icon: 'warning',
            title: '이메일 주소를 입력해주세요'
        })
        return
    }

    try {
        // 스타일을 포함한 HTML 생성
        const printContent = document.getElementById('printable-content')
        const styles = `
            <style>
                @page {
                    size: A4;
                    margin: 10mm;
                }
                body {
                    margin: 0;
                    padding: 0;
                    font-family: 굴림, Gulim, sans-serif;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
                table {
                    border-collapse: collapse;
                    width: 100%;
                }
                td {
                    padding: 0;
                    font-size: 12px;
                }
                .cborder2 {
                    border: 1px solid red;
                }
                .ttxt2 {
                    font-family: 굴림, Gulim, sans-serif;
                    font-size: 12px;
                    color: red;
                }
                .no-print {
                    display: none !important;
                }
                strong {
                    font-size: 12px !important;
                    font-weight: normal !important;
                }
            </style>
        `
        const htmlContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="UTF-8">
                ${styles}
            </head>
            <body>
                ${printContent.outerHTML}
            </body>
            </html>
        `
        
        const htmlBase64 = btoa(unescape(encodeURIComponent(htmlContent)))
        await taxAPI.sendEmail(email.value, htmlBase64)
        
        showEmailModal.value = false
        await Swal.fire({
            icon: 'success',
            title: '이메일이 전송되었습니다'
        })
    } catch (error) {
        console.error('이메일 전송 실패:', error)
        await Swal.fire({
            icon: 'error',
            title: '이메일 전송에 실패했습니다',
            text: error.message || '알 수 없는 오류가 발생했습니다'
        })
    }
}
</script>

<style scoped>
.select-container {
    margin-left: 400px;
    margin-bottom: 20px;
    width: 150px;
}

.custom-select {
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid #ddd;
}

.button-container {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin: 20px 0;
}

.modern-button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
}

.print-button {
    background-color: #f8f9fa;
    color: #212529;
    border: 1px solid #dee2e6;
}

.print-button:hover {
    background-color: #e9ecef;
}

.email-button {
    background-color: #007bff;
    color: white;
}

.email-button:hover {
    background-color: #0056b3;
}

.notice-box {
    margin: 20px auto;
    padding: 15px;
    border: 1px solid #4a90e2;
    border-radius: 4px;
    background-color: #f8f9ff;
    max-width: 800px;
}

.notice-box p {
    margin: 5px 0;
    color: #2c3e50;
    font-size: 14px;
}

.material-icons {
    font-size: 20px;
    margin-right: 4px;
    vertical-align: middle;
}

.modal-content {
    border-radius: 8px;
}

.modal-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 1rem;
}

.modal-body {
    padding: 1.5rem;
}

.form-group label {
    font-weight: 500;
    margin-bottom: 0.5rem;
}

.form-control {
    border-radius: 4px;
    border: 1px solid #ced4da;
    padding: 0.5rem 0.75rem;
}

.form-control:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
}

@media print {
    @page {
        size: A4;
        margin: 10mm;
    }

    .no-print,
    .navbar,
    .header,
    .footer,
    .select-container,
    .action-buttons,
    header,
    nav,
    .app-bar,
    .profile-section {
        display: none !important;
    }

    body,
    html {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        background-color: white;
    }

    #printable-content {
        margin: 0 auto;
        padding: 0;
        box-sizing: border-box;
        width: 100%;
        height: auto;
        position: relative;
        max-width: 210mm;
    }

    table {
        page-break-inside: avoid;
        width: 100%;
        margin: 0 auto;
    }

    body {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
}

body,
table,
tr,
td {
    font-family: 굴림, verdana, arial;
    font-size: 12px;
    color: #000000;
}

.ttxt2 {
    font-family: 굴림, verdana, arial;
    font-size: 12px;
    color: red;
}

.cborder2 {
    border-width: 1px;
    border-color: red;
    border-style: solid;
}

.ctit2 {
    font-size: 22px;
    color: red;
    font-weight: bold;
}

.ccmt2 {
    font-size: 12px;
    color: red;
}

.taxidno {
    font-size: 16px;
    color: black;
    font-weight: bold;
}

#printable-content {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
}
</style>